import {
  MISSION_STATUS_ENUM,
  MISSION_ENUM_TYPES,
} from '../../../../shared/constants'
import { authorization } from './../../../../Module/Auth/Auth'
import { formatToLocalDate } from '../../../../shared/libraries/utils/date'
import { isDefined } from '../../../../shared/libraries/utils/object'

const getEditableFields = (missionStatus, missionType) =>
  missionType === MISSION_ENUM_TYPES.LETTERBOX
    ? editableFieldsByStatusLB[missionStatus]
    : editableFieldsByStatusHTH[missionStatus]

// Vars
const editableFieldsByStatusHTH = authorization.isClient()
  ? {
      [MISSION_STATUS_ENUM.DRAFT]: ['locationId'],
      [MISSION_STATUS_ENUM.AVAILABLE]: [],
      [MISSION_STATUS_ENUM.BOOKED]: [],
      [MISSION_STATUS_ENUM.COMPLETED]: [],
      [MISSION_STATUS_ENUM.CHECKED_IN]: [],
      [MISSION_STATUS_ENUM.UNDER_REVIEW]: [],
      [MISSION_STATUS_ENUM.PAID]: [],
    }
  : {
      [MISSION_STATUS_ENUM.DRAFT]: [
        'dateTime',
        'locationId',
        'pickupTime',
        'payoutRatio',
        'payoutRatioComment',
        'userId',
        'draftPayAdjustment',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.AVAILABLE]: [
        'dateTime',
        'userId',
        'locationId',
        'pickupTime',
        'payoutRatio',
        'payoutRatioComment',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.BOOKED]: [
        'dateTime',
        'userId',
        'locationId',
        'payoutRatio',
        'payoutRatioComment',
        'checkInTime',
        'checkoutTime',
        'flyerInventoryId',
        // Allowing this because you can set both checkIn and checkout time to
        // complete the mission
        'checkoutFlyerQuantity',
        'unbookReason',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.CHECKED_IN]: [
        'payoutRatio',
        'payoutRatioComment',
        'checkInTime',
        'checkoutTime',
        'flyerInventoryId',
        // Allowing this because you can set both checkIn and checkout time to
        // complete the mission
        'checkoutFlyerQuantity',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.UNDER_REVIEW]: [
        'payoutRatio',
        'payoutRatioComment',
        'checkoutFlyerQuantity',
        'checkoutTime',
        'checkInTime',
        'flyerInventoryId',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.COMPLETED]: [
        'payoutRatio',
        'payoutRatioComment',
        'checkoutFlyerQuantity',
        'checkoutTime',
        'checkInTime',
        'flyerInventoryId',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.CANCELLED]: [
        'payoutRatio',
        'payoutRatioComment',
        'flyerInventoryId',
        'checkoutFlyerQuantity',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.PAID]: ['comments', 'label'],
    }

const editableFieldsByStatusLB = authorization.isClient()
  ? {
      [MISSION_STATUS_ENUM.DRAFT]: [],
      [MISSION_STATUS_ENUM.AVAILABLE]: [],
      [MISSION_STATUS_ENUM.BOOKED]: [],
      [MISSION_STATUS_ENUM.COMPLETED]: [],
      [MISSION_STATUS_ENUM.CHECKED_IN]: [],
      [MISSION_STATUS_ENUM.UNDER_REVIEW]: [],
      [MISSION_STATUS_ENUM.PAID]: [],
    }
  : {
      [MISSION_STATUS_ENUM.DRAFT]: [
        'pickupTime',
        'payoutRatio',
        'payoutRatioComment',
        'userId',
        'draftPayAdjustment',
        'comments',
        'dateTime',
        'label',
      ],
      [MISSION_STATUS_ENUM.AVAILABLE]: [
        'userId',
        'pickupTime',
        'payoutRatio',
        'payoutRatioComment',
        'comments',
        'dateTime',
        'label',
      ],
      [MISSION_STATUS_ENUM.BOOKED]: [
        'userId',
        'payoutRatio',
        'payoutRatioComment',
        'checkInTime',
        'checkoutTime',
        'flyerInventoryId',
        // Allowing this because you can set both checkIn and checkout time to
        // complete the mission
        'checkoutFlyerQuantity',
        'unbookReason',
        'comments',
        'dateTime',
        'label',
      ],
      [MISSION_STATUS_ENUM.CHECKED_IN]: [
        'payoutRatio',
        'payoutRatioComment',
        'checkInTime',
        'checkoutTime',
        'flyerInventoryId',
        // Allowing this because you can set both checkIn and checkout time to
        // complete the mission
        'checkoutFlyerQuantity',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.UNDER_REVIEW]: [
        'payoutRatio',
        'payoutRatioComment',
        'checkoutFlyerQuantity',
        'checkoutTime',
        'checkInTime',
        'flyerInventoryId',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.COMPLETED]: [
        'payoutRatio',
        'payoutRatioComment',
        'checkoutFlyerQuantity',
        'checkoutTime',
        'checkInTime',
        'flyerInventoryId',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.CANCELLED]: [
        'payoutRatio',
        'payoutRatioComment',
        'flyerInventoryId',
        'checkoutFlyerQuantity',
        'comments',
        'label',
      ],
      [MISSION_STATUS_ENUM.PAID]: ['comments', 'label'],
    }

const missionCheckinCheckoutTimeFormater = (missionTime, time) => {
  if (!time) return time

  const splitedTime = time.split(':')
  return formatToLocalDate(
    new Date(new Date(missionTime).setHours(splitedTime[0], splitedTime[1])),
  )
}

const isValidNumericValue = value => !isNaN(Number(value)) && isDefined(value)

const getTimestampAndSetTime = ({ missionDateTime, hoursStr }) => {
  const [hours, minutes] = hoursStr.split(':')
  const date = new Date(missionDateTime)
  date.setHours(Number(hours))
  date.setMinutes(Number(minutes))

  return +date
}

const convertTimeToTimestamp = date => (date ? +new Date(date) : null)

export {
  getEditableFields,
  getTimestampAndSetTime,
  convertTimeToTimestamp,
  missionCheckinCheckoutTimeFormater,
  isValidNumericValue,
}



// WEBPACK FOOTER //
// ./src/Containers/Form/Mission/EditMissionDetails/util.js